// Mock data for Velvet Cuts Férfi Szalon - Altegio alapján

export const services = [
  {
    id: 1,
    title: "Clean Cut",
    description: "Letisztult, gyors hajvágás egyszerű fazonokra. Buzzcut/egyhossz, clean fade (főként gépi munka), nyak- és oldalkontur géppel, alap styling.",
    price: "5.800 Ft",
    duration: "30 perc",
    icon: "scissors",
    category: "cuts",
    image: "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=1200&q=85&auto=format"
  },
  {
    id: 2,
    title: "Signature Cut",
    description: "Komplexebb, formázott frizurákhoz ajánlott, ahol az apró részletek is számítanak. Részletes átmenetek (peremes, V-forma), sok ollós munka felül, textúrázás, design elemek (csík stb.), precíz formaépítés és styling.",
    price: "6.800 Ft",
    duration: "45 perc",
    icon: "sparkles",
    category: "cuts",
    image: "https://images.unsplash.com/photo-1622286342621-4bd786c2447c?w=1200&q=85&auto=format"
  },
  {
    id: 3,
    title: "Prestige Cut",
    description: "Signature Cut minden eleme + Hajmosás prémium japán samponnal, részletes nyugodt tempójú frizuraépítés, precíz kontura japán borotvával, prémium aftershave, limitált wax használata, frissítő ital a szolgáltatás elején. Ez a szolgáltatás nem a gyorsaságról szól. A Prestige Cut azoknak készült, akik a részleteket és az élményt is értékelik.",
    price: "12.800 Ft",
    duration: "60 perc",
    icon: "star",
    category: "cuts",
    image: "https://images.unsplash.com/photo-1599351431202-1e0f0137899a?w=1200&q=85&auto=format"
  },
  {
    id: 4,
    title: "Szemöldök - Cérnázás",
    description: "Precíz forma és letisztult megjelenés. Kis részlet, ami sokat számít az összképen.",
    price: "800 Ft",
    duration: "5 perc",
    icon: "scan",
    category: "beard",
    image: "https://images.unsplash.com/photo-1595475207225-428b62bda831?w=1200&q=85&auto=format"
  },
  {
    id: 5,
    title: "Gyantázás - Orr vagy Fül",
    description: "Gyors, hatékony és tartósabb eredmény. Apró részlet, ami sokat javít a megjelenésen.",
    price: "1.500 Ft",
    duration: "10 perc",
    icon: "sparkles",
    category: "beard",
    image: "https://images.unsplash.com/photo-1599387737246-06ee8983a32e?w=1200&q=85&auto=format"
  },
  {
    id: 6,
    title: "Hajmosás - Előtte és Utána",
    description: "Teljes előkészítés és tiszta, ápolt zárás. A maximális komfortért ajánlott, ha igazán tiszta alapból szeretnél indulni.",
    price: "1.600 Ft",
    duration: "10 perc",
    icon: "droplet",
    category: "extras",
    image: "https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?w=1200&q=85&auto=format"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_groom-station-1/artifacts/bsvy4anb_IMG_3015.jpeg",
    alt: "Velvet Cuts szalon belső tér",
    category: "salon"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_groom-station-1/artifacts/1y5f8hzt_IMG_3014.jpeg",
    alt: "Velvet Cuts munkahely részlet",
    category: "salon"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1578390432942-d323db577792?w=600&q=80&auto=format",
    alt: "Modern precision haircut",
    category: "haircut"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1593702275687-f8b402bf1fb5?w=600&q=80&auto=format",
    alt: "Professional barber service",
    category: "service"
  },
  {
    id: 5,
    url: "https://images.pexels.com/photos/3998415/pexels-photo-3998415.jpeg?w=600&h=600&auto=compress",
    alt: "Classic barbershop precision",
    category: "haircut"
  },
  {
    id: 6,
    url: "https://images.pexels.com/photos/4625632/pexels-photo-4625632.jpeg?w=600&h=600&auto=compress",
    alt: "Technical fade work",
    category: "fade"
  },
  {
    id: 7,
    url: "https://images.pexels.com/photos/7697434/pexels-photo-7697434.jpeg?w=600&h=600&auto=compress",
    alt: "Professional styling",
    category: "styling"
  },
  {
    id: 8,
    url: "https://images.pexels.com/photos/2076930/pexels-photo-2076930.jpeg?w=600&h=600&auto=compress",
    alt: "Expert technique",
    category: "service"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Kovács Márk",
    role: "Szoftverfejlesztő",
    content: "A precíziós vágás minden várakozásomat felülmúlta. A részletekre való odafigyelés és a technikai megközelítés páratlan.",
    rating: 5
  },
  {
    id: 2,
    name: "Nagy Dávid",
    role: "Kreatív Igazgató",
    content: "Végre találtam egy helyet, ahol értik a modern férfi ápolást. A fade mindig tökéletes, és a hűségprogram remek.",
    rating: 5
  },
  {
    id: 3,
    name: "Szabó János",
    role: "Vállalkozó",
    content: "Professzionális, tiszta és hatékony. A konzultáció segített megtalálni a tökéletes frizurát. Nagyon ajánlom!",
    rating: 5
  }
];

export const staffMembers = [
  {
    id: 1,
    name: "Velvet Cuts Team",
    role: "Professional Barbers",
    specialty: "Precision Cuts & Modern Styling"
  }
];

export const availableTimeSlots = [
  "09:00", "09:30", "10:00", "10:30", "11:00", "11:30",
  "12:00", "12:30", "13:00", "13:30", "14:00", "14:30",
  "15:00", "15:30", "16:00", "16:30", "17:00", "17:30", "18:00"
];

export const loyaltyProgram = {
  visitsRequired: 8,
  discountPercentage: 6,
  permanentDiscountThreshold: 200000,
  permanentDiscountPercentage: 10,
  description: "Nálunk a hűséged értéket képvisel. Az Altegio rendszerében automatikusan gyűjtjük látogatásaidat"
};

export const contactInfo = {
  phone: "+36 30 782 1392",
  phoneRaw: "+36307821392",
  email: "info@velvetcuts.hu",
  address: "Petőfi Sándor utca 84",
  city: "2360 Gyál",
  hours: [
    { day: "Hétfő",     time: "11:00 - 20:00" },
    { day: "Kedd",      time: null },
    { day: "Szerda",    time: "11:00 - 20:00" },
    { day: "Csütörtök", time: "11:00 - 20:00" },
    { day: "Péntek",    time: "11:00 - 20:00" },
    { day: "Szombat",   time: null },
    { day: "Vasárnap",  time: null }
  ],
  closedLabel: "Zárva",
  mapCoordinates: {
    lat: 47.3866,
    lng: 19.2228
  },
  mapEmbedQuery: "Pet%C5%91fi%20S%C3%A1ndor%20utca%2084%2C%202360%20Gy%C3%A1l"
};
